import fetch from './fetch';
import {API_VERSION_STRING} from '../../const';
import {i18n} from '../../startup/i18n';

export default {
  getSettings: function(isLive = false, isValueBet= false) {
    return fetch(undefined, `/settings?valuebets=${isValueBet}&live=${isLive}&locale=${i18n.locale}`, 'get');
  },
  getUserData: function(payload = {}) {
    return fetch(payload.baseUrl, '/settings/user_data', 'get', payload);
  },
  getUserBookmakers: function({baseUrl, accessToken, locale}) {
    const url = `/${API_VERSION_STRING}user_bookmakers?access_token=${accessToken}&locale=${locale}`;
    return fetch(baseUrl, url, 'get');
  },
  getDirectories: function({baseUrl, accessToken, locale}) {
    return fetch(baseUrl, `/api/v1/directories?access_token=${accessToken}&locale=${locale}`);
  },
  getCurrencies: function({baseUrl}) {
    return fetch(baseUrl, `/api/v1/currencies`);
  },
  putZoomToServer: function(payload) {
    return fetch(undefined, `/profile/zoom`, 'put', payload);
  },
  getCountriesList: function({baseUrl, accessToken, locale}) {
    const url = `/${API_VERSION_STRING}countries?access_token=${accessToken}&locale=${locale}`;
    return fetch(baseUrl, url, 'get');
  },
  getLeaguesList: function() {
    return fetch(undefined, '/profile/leagues', 'get');
  },
  sendPollAnswer: function(payload) {
    return fetch(undefined, '/poll', 'post', payload);
  },
  keepAlive: function(payload) {
    return fetch(undefined, ' /alive', 'get', payload);
  },
  refreshToken: function({baseUrl, accessToken, locale, payload}) {
    const url = `/${API_VERSION_STRING}refresh_token?access_token=${accessToken}&locale=${locale}`;
    return fetch(baseUrl, url, 'post', payload);
  },
  setUserSettings: function(payload) {
    return fetch(undefined, '/profile/user_settings', 'put', payload);
  },
  updateShowHintsSetting: function(payload) {
    return fetch(undefined, '/profile/show_hints', 'put', payload);
  },
  updateCurrency: function({baseUrl, accessToken, locale, payload}) {
    const url = `/${API_VERSION_STRING}user_bookmakers?access_token=${accessToken}&locale=${locale}`;
    return fetch(baseUrl, url, 'put', payload);
  },
};
